




import { defineComponent } from '@vue/composition-api';

import TopManagerContainer from '@modules/topManager/TopManagerContainer.vue';

export default defineComponent({
    name: 'TopManagerPage',
    components: {
        TopManagerContainer,
    },
});
